import { Shield, Lock, FileText, Users, AlertCircle } from "lucide-react";

export const privacyPolicyData = [
  {
    id: "collection",
    title: "Information We Collect",
    icon: <FileText size={20} />,
    content: (
      <>
        <p>We collect information you provide directly to us when you create an account, specifically:</p>
        <ul>
          <li>Full Name and University ID.</li>
          <li>Email address and Phone number.</li>
          <li>Faculty, Academic Year/Level, and Gender.</li>
        </ul>
        <p>We also automatically collect certain technical data when you use our platform, such as your IP address and device type, to ensure security.</p>
      </>
    ),
  },
  {
    id: "usage",
    title: "How We Use Your Data",
    icon: <Users size={20} />,
    content: (
      <p>
        Your data is used primarily to verify your student status and to facilitate your participation in university activities. 
        We do not sell your personal data to third parties. We use your data to:
        <ul>
          <li>Manage your activity registrations.</li>
          <li>Send you important updates about events.</li>
          <li>Improve the security of our platform.</li>
        </ul>
      </p>
    ),
  },
  {
    id: "security",
    title: "Data Security",
    icon: <Lock size={20} />,
    content: (
      <p>
        We implement advanced security measures (including encryption and secure servers) to protect your personal information from unauthorized access. 
        However, no method of transmission over the Internet is 100% secure, so we cannot guarantee absolute security.
      </p>
    ),
  },
];

export const termsData = [
  {
    id: "acceptance",
    title: "Acceptance of Terms",
    icon: <Shield size={20} />,
    content: (
      <p>
        By accessing or using CampusPulse, you agree to be bound by these Terms. If you disagree with any part of the terms, 
        you may not access the service. These terms apply to all visitors, users, and others who access the Service.
      </p>
    ),
  },
  {
    id: "conduct",
    title: "Student Code of Conduct",
    icon: <Users size={20} />,
    content: (
      <p>
        As a student platform, we expect professional behavior. You agree NOT to:
        <ul>
          <li>Use the service for any illegal purpose.</li>
          <li>Harass, abuse, or harm another person.</li>
          <li>Post false or misleading information regarding university activities.</li>
          <li>Attempt to hack or disrupt the service infrastructure.</li>
        </ul>
      </p>
    ),
  },
  {
    id: "liability",
    title: "Limitation of Liability",
    icon: <AlertCircle size={20} />,
    content: (
      <p>
        CampusPulse is provided on an "AS IS" basis. We are not liable for any direct, indirect, incidental, 
        or consequential damages resulting from your use of the platform or participation in any real-world activities organized through it.
      </p>
    ),
  },
];